import { getBookings, getDetailedBooking, getCSVInfo, getInsurance, getDetailedBookingFromApi, getBookingByUser, getBookingsFilters } from './bookings'

export default {
  getBookings,
  getDetailedBooking,
  getCSVInfo,
  getInsurance,
  getDetailedBookingFromApi,
  getBookingByUser,
  getBookingsFilters
}
